import React, { lazy } from 'react';

import { Suspense } from '@lumapps/utils/components/Suspense';

import type { SpotlightProps } from './Spotlight';

const LazySpotlight = lazy(
    () =>
        import(
            /* webpackChunkName: 'lumx-spotlight' */
            './Spotlight'
        ),
);

export const Spotlight = (props: SpotlightProps) => (
    <Suspense>
        <LazySpotlight {...props} />
    </Suspense>
);
